module.exports = __webpack_public_path__ + "img/gold-mine.34a82ec7.jpg";